import { ActionReducerMap, ActionReducer, MetaReducer } from '@ngrx/store';
import { environment } from '../../../environments/environment';
import * as fromLayout from '../layout/layout.reducer';
import * as fromMonitoring from '../monitoring/monitoring.reducer';

export interface State {
  layout: fromLayout.LayoutState;
  monitoring: fromMonitoring.MonitoringState;
}

export const reducers: ActionReducerMap<State> = {
  layout: fromLayout.layoutReducer,
  monitoring: fromMonitoring.monitoringReducer,
};

/**
 * Logger meta-reducer for debugging state changes in development.
 * @param reducer - The reducer to wrap
 * @returns A wrapped reducer that logs state and action
 */
export function logger(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action): any {
    console.log('state', state);
    console.log('action', action);

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<State>[] = !environment.production
  ? [logger]
  : [];
